<template lang="pug">
  .standalone-page.login-page
    v-container.fill-height(fluid)
      v-layout(row align-center justify-center)
        v-flex(xs12 sm8 md4)
          p.header-title.pl-4.py-2.mb-0 LionDesk Sunset Admin
          v-card.p-2.mt-0
            v-card-title.v-card__title--primary.pb-2
              i.material-icons person
              span.title Sign in
            v-card-text
              v-form.login-form(@submit.prevent="handleLogin")
                v-text-field.login-input(
                  v-model="credentials.email"
                  label="Email/Username"
                  type="email"
                  required
                  outlined
                  autocomplete="email"
                  @input="onEmailInput"
                )
                v-text-field.login-input(
                  v-model="credentials.password"
                  label="Password"
                  type="password"
                  required
                  outlined
                  autocomplete="current-password"
                  @keyup.enter="handleLogin"
                )
                v-alert.mt-4(
                  v-if="error"
                  type="error"
                  dismissible
                  @input="error = null"
                  :value="!!error"
                ) {{ error }}
            v-card-actions
              v-spacer
              v-btn.login-btn(
                type="submit"
                :disabled="!isFormValid || isLoading"
                :loading="isLoading"
                :class="{ 'login-btn-enabled': isFormValid && !isLoading }"
                @click="handleLogin"
              ) Sign in
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'SunsetAdminLogin',
  data() {
    return {
      credentials: {
        email: '',
        password: '',
      },
      error: null,
      isLoading: false,
    };
  },
  computed: {
    isFormValid() {
      return this.credentials.email && this.credentials.password;
    },
  },
  methods: {
    ...mapActions('sunsetAdmin', [
      'login',
    ]),
    onEmailInput() {
      this.error = null;
    },
    async handleLogin() {
      this.error = null;
      this.isLoading = true;

      const result = await this.login({
        email: this.credentials.email,
        password: this.credentials.password,
      });

      this.isLoading = false;

      if (result.success) {
        this.$router.push('/sunset-admin/dashboard');
      } else {
        this.error = result.error;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.standalone-page {
  min-height: 100vh;
  background: #f5f5f5;
}

.header-title {
  font-family: -apple-system, "system-ui", "Segoe UI", Roboto, "Open Sans", Ubuntu, "Droid Sans", "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol" !important;
  font-size: 20px !important;
  font-weight: 600 !important;
  background-color: #000000;
  color: #ffffff !important;
}

.login-page {
  padding: 20px;
}

.fill-height {
  min-height: 100vh;
}

.p-2 {
  padding: 1rem;
}

.pb-2 {
  padding-bottom: 0.5rem;
}

.mt-4 {
  margin-top: 1rem;
}

.material-icons {
  vertical-align: middle;
  margin-right: 0.5rem;
}

.title {
  font-size: 1.25rem;
  font-weight: 500;
}

.login-btn {
  font-family: -apple-system, "system-ui", "Segoe UI", Roboto, "Open Sans", Ubuntu, "Droid Sans", "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol" !important;
  text-transform: capitalize !important;
}

.login-btn-enabled {
  background-color: #000000 !important;
  color: #ffffff !important;
}
</style>